// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1w0ax","title":"Info_title__3Eltw","selects":"Info_selects__3hQEv","requiredAsterisk":"Info_requiredAsterisk__1qtku"};